export const FontAktivGroteskRegular = "AktivGrotesk_Regular";
export const FontAktivGroteskBold = "AktivGrotesk_Bold";
